import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-navigate-to-simulator-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfNavigateToSimulatorIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfNavigateToSimulatorIcon(
  props: CcfNavigateToSimulatorIconProps
) {
  return (
    <SvgIcon {...props}>
      <path
        d="M2.16667 15.5C1.70833 15.5 1.31583 15.3367 0.989168 15.01C0.662501 14.6833 0.499446 14.2911 0.500001 13.8333V2.16667C0.500001 1.70833 0.663335 1.31583 0.990001 0.989168C1.31667 0.662501 1.70889 0.499446 2.16667 0.500001H8V2.16667H2.16667V13.8333H13.8333V8H15.5V13.8333C15.5 14.2917 15.3367 14.6842 15.01 15.0108C14.6833 15.3375 14.2911 15.5006 13.8333 15.5H2.16667ZM6.08333 11.0833L4.91667 9.91667L12.6667 2.16667H9.66667V0.500001H15.5V6.33333H13.8333V3.33333L6.08333 11.0833Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default CcfNavigateToSimulatorIcon;
